import { useState, useEffect } from "react";
import { Chart } from 'primereact/chart';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import styles from './Report.module.css';
import ChartJS from 'chart.js/auto';
import PieChartOutlabels from '@energiency/chartjs-plugin-piechart-outlabels';
import { SelectButton } from 'primereact/selectbutton';

ChartJS.register(PieChartOutlabels);

function Report(props) {
    const [riskTrendsData, setRiskTrendsData] = useState({});
    const [riskTrendsOptions, setRiskTrendsOptions] = useState({});
    const [originationData, setOriginationData] = useState({});
    const [positiveData, setPositiveData] = useState({});
    const [segmentData, setSegmentData] = useState({});
    const [commonOptions, setCommonOptions] = useState({});

    const [value, setValue] = useState(2);
    const items = [
        { name: 'YTD', value: 1, constant: true },
        { name: 'Monthly', value: 2, constant: true },
        { name: 'Quarterly', value: 3, constant: true },
        { name: 'Yearly', value: 4, constant: true }
    ];

    const firstData = {
        "labels": ["UPI", "Card", "Internet Banking", "Mobile Banking"],
        "datasets": [
            {
                "data": [350, 250, 200, 200],
                "backgroundColor": ["#FF9500", "#0D4B92FA", "#0096CC", "#FF2D55"],
                "borderWidth": 0
            }
        ]
    }

    const calculateChartData = (mainData) => {
        try {
            const monthOrder = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            const filteredData = Object.keys(mainData[0].monthly_counts).filter(month => {
                const counts = mainData[0].monthly_counts[month];
                return counts.high !== 0 || counts.low !== 0 || counts.medium !== 0;
            });

            const labelsyear = filteredData.sort((a, b) => {
                const [monthA, yearA] = a.split('-');
                const [monthB, yearB] = b.split('-');

                if (yearA !== yearB) {
                    return yearB - yearA;
                }
                return monthOrder.indexOf(monthB) - monthOrder.indexOf(monthA);
            });

            const lowCounts = labelsyear.map(label => mainData[0].monthly_counts[label].low);
            const mediumCounts = labelsyear.map(label => mainData[0].monthly_counts[label].medium);
            const highCounts = labelsyear.map(label => mainData[0].monthly_counts[label].high);

            const loginCount = mainData[0].login
            const transactionCount = mainData[0].transaction

            const FPCount = mainData[0].false_positive.yes
            const TPCount = mainData[0].false_positive.no

            const lowCount = mainData[0].low;
            const mediumCount = mainData[0].medium;
            const highCount = mainData[0].high;

            const labels2 = labelsyear.map(label => {
                const month = label.split('-')[0]
                return `${month.slice(0, 3)} ${label.split('-')[1]}`
            })

            const newChartData = {
                labels: labels2,
                datasets: [
                    {
                        data: lowCounts,
                        label: "Low",
                        backgroundColor: "#A6CEE3",
                    },
                    {
                        data: mediumCounts,
                        label: "Medium",
                        backgroundColor: "#67C9EE",
                    },
                    {
                        data: highCounts,
                        label: "High",
                        backgroundColor: "#367085",
                    },
                ],
            };

            const options1 = {
                responsive: true,
                //maintainAspectRatio: false,
                scales: {
                    x: {
                        grid: {
                            display: false,
                        },
                    },
                    y: {
                        grid: {
                            display: true,
                        },
                        ticks: {
                            suggestedMin: 0,
                            suggestedMax: 1800,
                            stepSize: 200,
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: true,
                        position: "top",
                    },
                },
            }

            setRiskTrendsData(newChartData);
            setRiskTrendsOptions(options1)

            const options2 = {
                responsive: false,
                color: "#495057",
                plugins: {
                    legend: {
                        position: "right",
                    },
                },
            }

            setCommonOptions(options2)

            setOriginationData({
                labels: ["Login", "Transaction"],
                datasets: [
                    {
                        label: "Incident Origination",
                        data: [loginCount, transactionCount],
                        backgroundColor: ["#67C9EE", "#FF9900"],
                        hoverOffset: 4,
                    },
                ],
            });

            setPositiveData({
                labels: ['True Positive', 'False Positive'],
                datasets: [{
                    data: [TPCount, FPCount],
                    backgroundColor: ['#367085', '#67C9EE'],
                    hoverOffset: 4
                }]
            });

            setSegmentData({
                labels: ['Low', 'Medium', 'High'],
                datasets: [{
                    data: [lowCount, mediumCount, highCount],
                    backgroundColor: ['#A6CEE3', '#67C9EE', '#367085'],
                    hoverOffset: 4
                }]
            });

        } catch (error) { console.log(error) }
    };

    // const params = `start_date=${start_date}&end_date=${end_date}`;

    const { isLoading, isFetching, data, isError, error } = useQuery({
        queryKey: ['dashboard', props.selectedStartDate, props.selectedEndDate],
        queryFn: () => axios.get('dashboardUrl').then(res => res.data),
    });

    // useEffect(() => {
    //     try {
    //         if (!isFetching && data) {
    //             const mainData = data.case_manager_data
    //             calculateChartData(mainData);
    //         }
    //     } catch (error) { console.log(error) }
    // }, [isFetching, data]);

    if (isLoading || isFetching) {
        return (
            <div className="centered-container flex justify-content-center align-items-center">
                <ProgressSpinner
                    className="custom-spinner"
                    strokeWidth="4"
                    animationDuration=".9s"
                />
            </div>
        )
    }

    // if (isError) {
    //     const res = error.response?.data;
    //     const message = res?.message;
    //     const msg = res?.msg;

    //     if (msg && (msg.includes("Missing cookie") || msg === "Token has expired")) {
    //         props.onLogout('expired');
    //         return null;
    //     }

    //     let displayMessage = "Error fetching data";
    //     if (message === "No record found") {
    //         displayMessage = "No records found";
    //     } else if (message === "Dont have permission to view") {
    //         displayMessage = "You are not authorized to view";
    //     }

    //     return (
    //         <div className="empty flex justify-content-center align-items-center bg-white m-2">
    //             {displayMessage}
    //         </div>
    //     );
    // }

    const options2 = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%',
        color: "#495057",
        layout: {
            padding: {
                left: 30,
                right: 30,
                top: 20,
                bottom: 30
            }
        },
        plugins: {
            legend: {
                display: false
            },
            outlabels: {
                display: true,
                color: '#4B4B4B',
                backgroundColor: 'white',
                text: '%l %v',
                stretch: 20,
            }

        },
    }

    const datatwo = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                type: 'bar',
                label: 'Dataset 1',
                backgroundColor: '#FF9500',
                data: [50, 25, 12, 48, 90, 76, 42]
            },
            {
                type: 'bar',
                label: 'Dataset 3',
                backgroundColor: '#FF2D55',
                data: [41, 52, 24, 74, 23, 21, 32]
            },
            {
                type: 'bar',
                label: 'Dataset 2',
                backgroundColor: '#0D4B92FA',
                data: [21, 84, 24, 75, 37, 65, 34]
            },
            {
                type: 'bar',
                label: 'Dataset 3',
                backgroundColor: '#0096CC',
                data: [41, 52, 24, 74, 23, 21, 32]
            }
        ]
    };

    const centerTextPlugin = {
        id: 'centerText',
        afterDraw(chart) {
            const { ctx, width, height } = chart;
            ctx.save();

            const lines = [
                { text: 'First Line', font: '20px Arial', color: 'black' },
                { text: 'Total Frauds', font: '12px Arial', color: '#8E8E8E' }
            ];

            const lineHeight = 22;
            const totalHeight = lineHeight * lines.length;
            const centerX = width / 2;
            const centerY = height / 2;
            let startY = centerY - totalHeight / 2 + lineHeight / 2;

            lines.forEach(line => {
                ctx.font = line.font;
                ctx.fillStyle = line.color;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(line.text, centerX, startY);
                startY += lineHeight;
            });

            ctx.restore();
        }
    };

    const centerTextPluginTwo = {
        id: 'centerText',
        afterDraw(chart) {
            const { ctx, width, height } = chart;
            ctx.save();

            const lines = [
                { text: 'First Line', font: '20px Arial', color: 'black' },
                { text: 'Total Cases', font: '12px Arial', color: '#8E8E8E' }
            ];

            const lineHeight = 22;
            const totalHeight = lineHeight * lines.length;
            const centerX = width / 2;
            const centerY = height / 2;
            let startY = centerY - totalHeight / 2 + lineHeight / 2;

            lines.forEach(line => {
                ctx.font = line.font;
                ctx.fillStyle = line.color;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(line.text, centerX, startY);
                startY += lineHeight;
            });

            ctx.restore();
        }
    };


    const optionstwo = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
            legend: {
                display: false
            },
            tooltips: {
                mode: 'index',
                intersect: false
            },

        },
        barThickness: 30,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false
                },

            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'No. of Cases',
                    color: '#8E8E8E',
                    font: {
                        size: 12,

                    }
                }
            }
        }
    };

    return (
        <div className={`${styles.dashboard}`} >
            <div className="card flex justify-content-end mt-2 pr-8">
                <SelectButton className="select-btn" value={value} onChange={(e) => setValue(e.value)} optionLabel="name" options={items} optionDisabled="constant" />
            </div>
            <div className={`mt-2`} >
                <div className={`${styles.chart_container} flex flex-wrap  mt-2 w-full`}>
                    <div className={`${styles.main_chart} bg-white p-2`}>
                        <Chart type="doughnut" data={firstData} options={options2} plugins={[centerTextPlugin]} className="flex justify-content-center align-items-center m-auto" height="250px"
                            width={500} />
                        <p className={`${styles.heading}`}>Multi-Channel Fraud Overview</p>

                    </div>
                    <div className={`${styles.main_chart_one} bg-white p-2`}>
                        <Chart type="bar" data={datatwo} options={optionstwo} className={`flex  align-items-center}`} height="250px" />
                        <p className={`${styles.heading}`}>Multi-Channel Fraud Breakup</p>

                    </div>
                    <div className={`${styles.main_chart} bg-white p-2`}>
                        <Chart type="doughnut" data={firstData} options={options2} plugins={[centerTextPluginTwo]} className="flex justify-content-center align-items-center m-auto" height="250px" width={500} />
                        <p className={`${styles.heading}`}>Investigation Overview</p>

                    </div>
                    <div className={`${styles.main_chart_one} bg-white p-2`}>
                        <Chart type="bar" data={datatwo} options={optionstwo} className={`flex  align-items-center}`} height="250px" />
                        <p className={`${styles.heading}`}>Investigation Breakup</p>

                    </div>
                </div>
            </div >
        </div>
    );
}

export default Report;
